import React from 'react';
import { Container, Title, Text, Button, Stack, Paper } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

/**
 * AccessDenied — page shown when a user tries to access an unauthorized route.
 *
 * sprint-104 (epic-013 Sprint B, step 2d / S5). MineMiner SPA serves a single
 * role family (MineMinerRep / MineMinerAdmin / Admin); on access denied, send
 * authenticated reps back to `/MineMiner` and unauthenticated visitors to
 * `/login`.
 */
export const AccessDenied: React.FC = (): React.ReactElement => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleGoBack = (): void => {
    if (isAuthenticated) {
      navigate('/MineMiner');
    } else {
      navigate('/login');
    }
  };

  return (
    <Container size="sm" mt="4rem">
      <Paper shadow="md" radius="md" p="xl">
        <Stack align="center" gap="lg">
          <Title order={1} fz="4rem">
            403
          </Title>

          <Title order={2}>Access Denied</Title>

          <Text c="dimmed" ta="center">
            You do not have permission to access this page. If you believe this is an error,
            please contact your administrator.
          </Text>

          <Button onClick={handleGoBack} size="lg">
            Go Back
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};
